import i18next from 'i18next';

/** i18next.t as plain text for props and errors that require a string; the backoffice resources never contain null. */
export const tr = (key: string, options: Record<string, unknown> = {}): string => String(i18next.t(key, options) ?? key);
